import { Navigate, Outlet, useLocation } from 'react-router'
import { UserRole } from '../../models/User'
import { useAppSelector } from '../../store'

const MenteeAuth = () => {
  const myRole = useAppSelector((state) => state.user.me.userRole)
  const location = useLocation()

  return myRole === UserRole.GUEST ? (
    <Navigate to="/login" state={{ from: location }} />
  ) : (
    <Outlet />
  )
}

export default MenteeAuth
